import { Icon, type IconProps } from "@chakra-ui/react";
import React from "react";

export function OnboardAudiencesIcon(props: IconProps) {
  return (
    <Icon width="72" height="72" viewBox="0 0 72 72" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <circle cx="36" cy="36" r="36" fill="white" />
      <path d="M36.0304 24.5092L36.0304 18.2664" stroke="#191A1C" strokeWidth="1.2" />
      <path d="M35.9696 47.4908L35.9696 53.7336" stroke="#191A1C" strokeWidth="1.2" />
      <path d="M47.4907 36.0305L53.7336 36.0305" stroke="#191A1C" strokeWidth="1.2" />
      <path d="M24.5093 35.9695L18.2664 35.9695" stroke="#191A1C" strokeWidth="1.2" />
      <path d="M44.1473 27.8956L48.5616 23.4812" stroke="#191A1C" strokeWidth="1.2" />
      <path d="M27.8528 44.1044L23.4384 48.5188" stroke="#191A1C" strokeWidth="1.2" />
      <path d="M44.1033 44.1472L48.5177 48.5615" stroke="#191A1C" strokeWidth="1.2" />
      <path d="M27.8967 27.8528L23.4823 23.4385" stroke="#191A1C" strokeWidth="1.2" />
      <circle
        cx="55.4636"
        cy="35.9988"
        r="2.53642"
        transform="rotate(90 55.4636 35.9988)"
        fill="#40E398"
        stroke="#191A1C"
        strokeWidth="1.2"
      />
      <circle
        cx="16.5364"
        cy="35.999"
        r="2.53642"
        transform="rotate(-90 16.5364 35.999)"
        fill="#40E398"
        stroke="#191A1C"
        strokeWidth="1.2"
      />
      <circle
        cx="49.7622"
        cy="22.2365"
        r="2.53642"
        transform="rotate(45 49.7622 22.2365)"
        fill="#40E398"
        stroke="#191A1C"
        strokeWidth="1.2"
      />
      <circle
        cx="22.2378"
        cy="49.7635"
        r="2.53642"
        transform="rotate(-135 22.2378 49.7635)"
        fill="#40E398"
        stroke="#191A1C"
        strokeWidth="1.2"
      />
      <circle cx="35.9999" cy="35.9584" r="7.13173" stroke="#191A1C" strokeWidth="1.2" />
      <circle cx="35.9998" cy="16.5364" r="2.53642" fill="#40E398" stroke="#191A1C" strokeWidth="1.2" />
      <circle
        cx="36.0002"
        cy="55.4636"
        r="2.53642"
        transform="rotate(-180 36.0002 55.4636)"
        fill="#40E398"
        stroke="#191A1C"
        strokeWidth="1.2"
      />
      <circle
        cx="49.7626"
        cy="49.7644"
        r="2.53642"
        transform="rotate(135 49.7626 49.7644)"
        fill="#40E398"
        stroke="#191A1C"
        strokeWidth="1.2"
      />
      <circle
        cx="22.2374"
        cy="22.2356"
        r="2.53642"
        transform="rotate(-45 22.2374 22.2356)"
        fill="#40E398"
        stroke="#191A1C"
        strokeWidth="1.2"
      />
    </Icon>
  );
}
